import { Box, Typography } from '@mui/material';
import { LoadingWrapper } from './LoadingWrapper';
import { UserAvatar } from './UserAvatar';
import { colors } from '@src/styles';

interface UserBoxProps {
  label: string;
  userId: string | null;
  userNames: Record<string, string>;
  isLoadingUsers: boolean;
  orientation?: 'default' | 'vertical';
}

export const UserBox = ({ label, userId, userNames, isLoadingUsers, orientation = 'default' }: UserBoxProps) => {
  const getUserInitial = () => {
    if (!userId) return '-';
    if (userNames[userId]) {
      return userNames[userId].charAt(0).toUpperCase();
    }
    return userId.charAt(0).toUpperCase();
  };

  const getUserName = () => {
    if (!userId) return 'Nenhum';
    const name = userNames[userId] || userId;
    return name.length > 25 ? `${name.slice(0, 25)}...` : name;
  };

  if (orientation === 'vertical') {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
        <LoadingWrapper isLoading={isLoadingUsers} skeletonHeight={26} skeletonWidth={110}>
          <UserAvatar initial={getUserInitial()} name={getUserName()} size="medium" />
        </LoadingWrapper>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        '& .MuiTypography-caption': {
          display: 'inline',
          marginBottom: 0,
        },
      }}
    >
      <Typography
        variant="caption"
        sx={{
          fontFamily: "'JetBrains Mono', monospace",
          fontSize: '10px',
          letterSpacing: '0.12em',
          textTransform: 'uppercase',
          color: colors.brand.textMuted,
          whiteSpace: 'nowrap',
        }}
      >
        {label}
      </Typography>
      <LoadingWrapper isLoading={isLoadingUsers} skeletonHeight={22} skeletonWidth={100}>
        <UserAvatar initial={getUserInitial()} name={getUserName()} size="small" />
      </LoadingWrapper>
    </Box>
  );
};
